import { CalculationReportController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Shows the calculation report builder for ad hoc calculation reports.
 * @example
 * ```html
 * <salaxy-calculation-report template-id="plain"></salaxy-calculation-report>
 * ```
 */
export class CalculationReport extends ComponentBase {

   /**
    * The following component properties (attributes in HTML) are bound to the Controller.
    * For detailed functionality, refer to [controller](#controller) implementation.
    */
    public bindings = {
      /** Template for the report */
      templateId: "<",
    };

    /** Uses the CalculationReportController */
    public controller = CalculationReportController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/report/CalculationReport.html";

}
